import { render, staticRenderFns } from "./AccountOrderTable.vue?vue&type=template&id=4c859b4c&"
import script from "./AccountOrderTable.vue?vue&type=script&lang=js&"
export * from "./AccountOrderTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports